<template>
  <div class="d-flex justify-content-center mb-3">
    <ul class="nav nav-pills">
      <li class="nav-item">
        <router-link
          to="/laudos/visao"
          class="nav-link"
          :class="ativo == 'visao' ? 'active' : ''"
        >Visão Geral</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/laudos/lista"
          class="nav-link"
          :class="ativo == 'lista' ? 'active' : ''"
        >Lista de Trabalho</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/laudos/amostras"
          class="nav-link"
          :class="ativo == 'amostras' ? 'active' : ''"
        >Amostras</router-link>
      </li>
      <li class="nav-item" v-if="false">
        <router-link
          to="/laudos/ocorrencias"
          class="nav-link"
          :class="ativo == 'ocorrencias' ? 'active' : ''"
        >Ocorrências</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["ativo"]
};
</script>